export default {
  step1Title: {
    en: 'Where would you rather be?',
  },
  step1NewTitle: {
    en: '15 sec survey. CHOOSE PRODUCTS YOU’D LIKE TO GET',
  },
  step2Title: {
    en: 'What do you naturally gravitate to?',
  },
  step2NewTitle: {
    en: 'We’d Love To Hear From You!',
  },
  step3Title: {
    en: 'What is your absolutely favorite drink?',
  },

  step1TitleMen: {
    en: 'What would you rather do?',
  },

  subTitle: {
    en: 'Please choose one!',
  },
  step1SubTitle: {
    en: 'Tell us what products you’d like to try as part of your Scentbird subscription and we’ll add them in future.',
  },
  step2SubTitle: {
    en: 'Tell us what products you’d like to try as part of your Scentbird subscription.',
  },

  bakery: {
    en: 'bakery',
  },
  flowerShop: {
    en: 'flower shop',
  },
  orangeGrove: {
    en: 'orange grove',
  },
  privateLibrary: {
    en: 'private library',
  },
  seaShore: {
    en: 'sea shore',
  },
  spiceMarket: {
    en: 'spice market',
  },

  berries: {
    en: 'berries',
  },
  chocolate: {
    en: 'chocolate',
  },
  flowers: {
    en: 'flowers',
  },
  incense: {
    en: 'incense',
  },
  leather: {
    en: 'leather',
  },
  oranges: {
    en: 'oranges',
  },
  suede: {
    en: 'suede',
  },
  wood: {
    en: 'wood',
  },

  cocktail: {
    en: 'cocktail',
  },
  coffee: {
    en: 'coffee',
  },
  milkShake: {
    en: 'milk shake',
  },
  smoothie: {
    en: 'smoothie',
  },
  tea: {
    en: 'tea',
  },
  water: {
    en: 'water',
  },
  wine: {
    en: 'wine',
  },
  wiskey: {
    en: 'wiskey',
  },

  golfing: {
    en: 'golfing',
  },
  hiking: {
    en: 'hiking',
  },
  meditating: {
    en: 'meditating',
  },
  sailing: {
    en: 'sailing',
  },
  sightseeing: {
    en: 'sightseeing',
  },
  snowboarding: {
    en: 'snowboarding',
  },

  cinnamon: {
    en: 'cinnamon',
  },
  lemons: {
    en: 'lemons',
  },
  spices: {
    en: 'spices',
  },
  woods: {
    en: 'woods',
  },

  beer: {
    en: 'beer',
  },
  bloodyMarry: {
    en: 'bloody marry',
  },
  mojito: {
    en: 'mojito',
  },
  scotch: {
    en: 'scotch',
  },

  fineFragrance: {
    en: 'Fine Fragrance',
  },
  bodyWash: {
    en: 'Body Wash & Scrub',
  },
  bubbleBath: {
    en: 'Bath Bombs & Bubble Bath',
  },
  soapBars: {
    en: 'Soap Bars',
  },
  bodyOil: {
    en: 'Body Oil & Shower Oil',
  },
  bodyLotion: {
    en: 'Body Lotion & spray',
  },

  handCare: {
    en: 'Hand Care & Feet Care',
  },
  sunCare: {
    en: 'Sun Care & SPF',
  },
  antiBacterial: {
    en: 'Anti-bacterial products',
  },
  deodorant: {
    en: 'Deodorant',
  },
  conditioner: {
    en: 'Shampoo & Conditioner',
  },
  dryShampoo: {
    en: 'Dry Shampoo',
  },

  candle: {
    en: 'Candle',
  },
  diffuser: {
    en: 'Room spray & Diffuser',
  },
  toner: {
    en: 'Micellar Water & Toner',
  },
  lipBalm: {
    en: 'Lip balm & Lip scrub',
  },
  faceWash: {
    en: 'Face Wash & Scrub',
  },
  faceMask: {
    en: 'Face Mask & Scrub',
  },

  serum: {
    en: 'Face Moisturizer & Serum',
  },
  eyeCream: {
    en: 'Eye Cream',
  },
  wipes: {
    en: 'Makeup remover & wipes',
  },
  supplements: {
    en: 'Supplements',
  },
  makeup: {
    en: 'Makeup',
  },
  nailCare: {
    en: 'Nail Care',
  },
}
